export default [
  {
    title: 'breadcrumb.player',
    route: 'list-player',
    icon: '',
    resource: 'player',
    action: 'read',
  },
]
